<template>
    <div>
        <swb-query-sort-area name="query-sort-block" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :custConfEnabled="custConfEnabled" ref="query_model_ctrl" :queryHandler="queryHandler"></swb-query-sort-area>
        <swb-result-table class="mt10" name="result_table" :confKey="confKey" :configAuto="true" :custConfEnabled="custConfEnabled" ref="result_table" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="theTableHeight" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    //
    import contractApi from '../../api/contract'
    //
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-contract-servc-list-for-select',
        desc: '合同设备服务选择',
        props: {
            selectIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            params: {
                type: Object,
                default: function () {
                    return {}
                },
            }
        },
        data: function () {
            return {
                confKey: "swb-contract-servc-list-for-select",
                queryOnLoad: true,
                custConfEnabled: true,
                theTableHeight: '500',
                //
                needPager: false, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                purchFeeTypeMap: getEnumMap('purchFeeType', 'value2text')
            }
        },
        created: function () {
            //
        },
        mounted() {
            //
            this.initResultTable();
            //回显数据处理
            let initChecked = this.selectIds;
            let resultTable = this.$refs.result_table;
            resultTable.setInitChecked(initChecked, true);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                });
            },
            renderTable(rows) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getDataList();
            },
            getDataList: function () {
                let self = this;
                let queryModel = self.queryModel;
                let postData = {};
                let filterItems = Utils.merge(this.params, queryModel.filterItems);
                postData.filterItems = filterItems;
                //
                let theLoad = MsgBox.loading();
                contractApi.getContractServc(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        //
                        self.renderTable(result.data || []);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let selectList = this.getTableSelection() || [];
                let result = {};
                if(selectList.length <= 0) {
                    result.type = "warn";
                    result.message = "请选择至少一个服务！";
                } else {
                    result.type = "info";
                    result.data = selectList;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractServcListForSelect.vue